



import { Vue, Component } from "vue-property-decorator";

import SettingComponent from "@/components/admin/setting.vue";

@Component({
  name: "Setting",
  components: {
    SettingComponent,
  },
})
export default class Setting extends Vue {}
